<template>
  <div id="app">
    <LaHeader msg="深圳斗鲸科技" />
    <LaIntroduce />
    <LaAdvantage/>
    <LaAdvertising />
    <LaWinCooperation/>
    <LaCooperativeCustomers />
    <Camera />
    <LaunchPartner />
    <LaBottomLayout />
<!--    <my-header msg="旌斗云媒体引擎"/>-->
<!--    <my-content />-->
<!--    <my-preponderance />-->
<!--    <my-footer />-->
  </div>
</template>

<script>
  import LaHeader from "./components/LaHeader"
  import LaIntroduce from "./components/LaIntroduce.vue"
  import LaAdvertising from "./components/LaAdvertising.vue"
  import LaAdvantage from  "./components/LaAdvantage.vue"
  import LaWinCooperation from  "./components/LaWinCooperation.vue"
  import LaCooperativeCustomers from "./components/LaCooperativeCustomers.vue"
  import Camera from "./cameraComponents/camera"
  import LaunchPartner from "./components/LaunchPartner";
  import LaBottomLayout from "./components/LaBottomLayout";
// import MyHeader from './components/MyHeader'
// import MyContent from './components/MyContent'
// import MyPreponderance from "@/components/MyPreponderance"
// import MyFooter from "@/components/MyFooter"


export default {
  name: 'App',
  components: {
    LaHeader,
    LaIntroduce,
    LaAdvertising,
    LaAdvantage,
    LaWinCooperation,
    LaCooperativeCustomers,
    Camera,
    LaunchPartner,
    LaBottomLayout
      // MyHeader,
      // MyContent,
      // MyPreponderance,
      // MyFooter
  }
}
</script>

<style>
  html {
    -webkit-text-size-adjust: 100%;
  }

  body {
    margin: 0;
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
    font-size: 1rem;
    font-weight: 400;
    background-color: #fff;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
</style>
